import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { PackageService } from '../../services/package-service';
import { convertPackagesWeightAndDimensions } from '../../services/unit-services/package-services/packages-unit-conversion-service';
import Global from '../../store/global-selectors';
import { emptyArray } from 'ui-components/default-props/empty';

// we use "packageId" to track packages because packageTypeIds are not unique across carriers
// 'packageTypeId-isCustom(bool)-carrierId'
export const addPackageId = (entityPackages, accountPackages) => {
  if (!entityPackages || entityPackages.length === 0) {
    return emptyArray;
  }

  if (entityPackages.every((p) => p.packageId)) {
    return entityPackages;
  }

  const singlePackage = entityPackages[0];
  const realPackage = PackageService.findBestGuessPackageByPackageTypeId(singlePackage.packageTypeId, accountPackages);

  return entityPackages.map((p) => ({
    ...p,
    packageId: `${p?.packageTypeId || 'null'}-${realPackage?.isCustom ?? 'false'}-${realPackage?.carrierId || 'null'}`,
    isCustom: realPackage?.isCustom,
  }));
};

export const useConfigurePackages = () => {
  const accountPackages = useSelector(Global.selectSellerPackages);
  const sellerDefaultWeightUnit = useSelector(Global.selectSellerDefaultWeightUnit);
  const sellerDefaultDimensionsUnit = useSelector(Global.selectSellerDefaultDimensionUnit);

  const configurePackages = useCallback(
    (entityPackages) => {
      const packagesWithPackageId = addPackageId(entityPackages, accountPackages);
      return convertPackagesWeightAndDimensions(packagesWithPackageId, sellerDefaultWeightUnit, sellerDefaultDimensionsUnit);
    },
    [accountPackages, sellerDefaultWeightUnit, sellerDefaultDimensionsUnit],
  );
  return configurePackages;
};
